import local from "../classes/local";
import getEnvironment from "./get.environment";

export const getChatUrl = () => {
    const language = local.getItem('language', 'English');
    const chatUrlPrefix = getEnvironment() === 'production' ? 'https://chat.mymedicare.gov' : '';
    const langParam = language === 'English' ? '?Language=en-us' : '?Language=es-mx';
    return `${chatUrlPrefix}/chatclient/chatrequest.aspx${langParam}`;
};